export default __webpack_public_path__ + "static/media/groupe-1283.7466bdc3.svg";